import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  NavLink,
  HashRouter
} from "react-router-dom";
import Icon from "@material-ui/core/Icon";
import NavLinks from "../NavLinks/NavLinks";
import { navProps, linkTypes } from "../../../interfaces/interfaces";
import {
  navBarHighlightColor,
  dropdownHighlightColor
} from "../../../styles/master";
import ScrollToTopRoute from "./ScrollToTop";
import ScrollToTop from "./ScrollToTop";

import styles from "./TopNavBar.module.scss";
import stickyStyles from "./StickyNavBar.module.scss";

class NavBar extends Component<navProps> {
  state: navProps;

  constructor(props: navProps) {
    super(props);
    this.state = { ...props };
    this.collapseDropDownMenu = this.collapseDropDownMenu.bind(this);
  }

  onPageScroll(position: number) {
    this.setState({ scrollPosition: position });
  }

  toggleDropDownMenu() {
    this.setState({ dropDownClosed: !this.state.dropDownClosed });
  }

  collapseDropDownMenu() {
    this.setState({ dropDownClosed: true });
  }

  componentDidMount() {
    window.addEventListener("scroll", e => this.manageScroll(e));
  }

  renderStickyHeader() {
    const offset = this.state.scrollPosition;
    const header = document.getElementById("topBarContainer");
    if (!header) return "hidden";
    const headerHeight = header.clientHeight;
    if (headerHeight - offset < 0) return "sticky";
    return "hidden";
  }

  manageScroll(event: any) {
    this.onPageScroll(window.pageYOffset);
  }

  render() {
    return (
      <div id="nav">
        {this.topNavBar()}
        {this.stickyNavBar()}
      </div>
    );
  }

  stickyNavBar() {
    const isSticky = this.renderStickyHeader();
    return (
      <div
        id={stickyStyles.stickyNavContainer}
        className={stickyStyles[isSticky]}
      >
        <span id={stickyStyles.stickyNavBar}>
          <NavLink
            exact={true}
            to="/"
            className={stickyStyles.a}
            id={stickyStyles.stickyCompanyName}
          >
            {this.logo("stickyCompanyLogo")}
          </NavLink>
          <NavLinks
            displayStyle={linkTypes.desktop}
            slideDownAnimation={false}
            isSticky={true}
            activeColor={navBarHighlightColor}
          />
        </span>
      </div>
    );
  }

  topNavBar() {
    return (
      <div id="topBarContainer">
        {this.infoBar()}
        <div className={styles.navContainer}>
          <span id={styles.navBar}>
            <NavLink
              exact={true}
              to="/"
              className={styles.a}
              id={styles.companyName}
            >
              {this.logo("companyLogo")}
            </NavLink>
            <NavLinks
              displayStyle={linkTypes.desktop}
              slideDownAnimation={false}
              activeColor={navBarHighlightColor}
            />
            <div
              onClick={this.toggleDropDownMenu.bind(this)}
              id={styles.dropDownIconContainer}
            >
              <Icon style={{ fontSize: "1.5rem" }} id={styles.dropDownIcon}>
                menu
              </Icon>
            </div>
          </span>
        </div>
        <NavLinks
          displayStyle={linkTypes.mobile}
          slideDownAnimation={true}
          closed={this.state.dropDownClosed}
          activeColor={dropdownHighlightColor}
          onClick={this.collapseDropDownMenu}
        />
      </div>
    );
  }

  infoBar() {
    return (
      <div id={styles.infoContainer}>
        <div id={styles.infoBar}>
          <span className={styles.infoWithPadding}>
            <Icon className={styles.icons}>phone</Icon>
            215-230-3324 x100 (all inquiries)
          </span>
          <span className={styles.infoWithPadding} id={styles.email}>
            <Icon className={styles.icons}>email</Icon>
            michael.austin@powdersolutions.com
          </span>
          <span className={styles.span}>
            <Icon className={styles.icons}>place</Icon>
            98 Spring Lake Drive New Britain, PA 18901
          </span>
        </div>
      </div>
    );
  }

  logo(placement: string) {
    return (
      <svg viewBox="568 40 841 125" id={styles[placement]}>
        <text
          fontFamily="Roboto Condensed"
          fill="#1f2770"
          className={styles.headerText}
          y="115.328125"
          x="568.2916870117188"
        >
          Powder Solutions Inc.
        </text>
        <line
          x1="568.2916870117188"
          y1="120.328125"
          x2="1409.0416870117188"
          y2="120.328125"
          stroke="#6e869e"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <text
          fontFamily="Roboto"
          fill="#1f2770"
          className={styles.serviceText}
          y="153.984375"
          x="615.5791870117188"
        >
          Pulverizing
        </text>
        <text
          fontFamily="Roboto"
          fill="#1f2770"
          className={styles.serviceText}
          y="153.984375"
          x="818.5385620117188"
        >
          Screening
        </text>
        <text
          fontFamily="Roboto"
          fill="#1f2770"
          className={styles.serviceText}
          x="1007.0291870117187"
          y="153.984375"
        >
          Blending
        </text>
        <text
          fontFamily="Roboto"
          fill="#1f2770"
          className={styles.serviceText}
          x="1178.0354370117188"
          y="153.984375"
        >
          Repackaging
        </text>
        <circle r="3" fill="#6e869e" cx="794.8948120117187" cy="144.984375" />
        <circle r="3" fill="#6e869e" cx="983.3854370117188" cy="144.984375" />
        <circle r="3" fill="#6e869e" cx="1154.3916870117187" cy="144.984375" />
      </svg>
    );
  }
}

export default NavBar;
